import axios from 'axios'
import { AUTH_HEADERS_BLOB, AUTH_HEADERS } from '../utils/config'
export default {
  getZip (idList) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}file/zip?${idList}`, AUTH_HEADERS_BLOB())
  },
  getAll (data) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}file/list?pageIndex=${data.page}&pageSize=${data.itemsPerPage}&archived=${data.archived}`, data.search, AUTH_HEADERS())
  },
  getByTask (data) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}file/${data.taskID}/list?archived=${data.archived}`, AUTH_HEADERS())
  }
}
